<app-page-head></app-page-head>

<div class="row">
  <div class="col-md-12">

    <div class="table-responsive" *ngIf="!isHistoricsEmpty">
      <table class="table table-sm table-striped">
        <thead>
          <tr>
            <th scope="col" class="text-center">Id</th>
            <th scope="col" class="text-center">Alterado por</th>
            <th scope="col" class="text-center">Documento</th>
            <th scope="col" class="text-center">Versão</th>
            <th scope="col" class="text-center">Atualizado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of historics?.data">
            <th scope="row" class="text-center">
              {{ item?.id }}
            </th>
            <td class="text-center">
              <a>
                {{ item?.modified.name }}
              </a>
            </td>
            <td class="text-center">
              {{ item?.document | document }}
            </td>
            <td class="text-center">
              {{ item?.version }}
            </td>
            <td class="text-center">
              {{ item?.updated_at | date:'dd/M/y H:m' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
